<template>
  <b-modal
    v-model="mostraQRCode"
    :title="titulo"
    size="lg"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    @hide="$emit('fechouModal', true)"
  >
    <div class="d-flex justify-content-center text-center">
      <img id="imgQrCode" :src="qrCodeImage" alt="" />
    </div>

    <div class="row text-center">
      <span class="font-size-16"><strong>{{ $tools.converteReal(valor) }}</strong></span>
    </div>

    <div class="row">
      <div class="col-md-12 d-flex justify-content-center">
        <textarea id="text-copiaCola" v-model="textAreaData" style="width: 100%; height:85px; margin-top: 10px; margin-bottom: 10px; resize: none; border-radius: 10px" disabled></textarea>
      </div>
      
      <div id="copiaQrCode" class="d-none">
        {{ textAreaData }}
      </div>
      
      <div class="col-md-12 d-flex justify-content-center" style="margin-bottom: 6px;">
        <b-button :variant="buttonVariant" :style="buttonStyle" @click="copiarConteudo">
          Copiar Código do QR Code <i class="mdi mdi-content-copy"></i>
        </b-button>
        <b-button variant="primary" class="mx-1" @click="enviarEmail" disabled>
          Enviar Para Meu E-mail <i class="mdi mdi-email-send"></i>
        </b-button>
      </div>
    </div>
    
    <div class="row">
      <div class="d-flex m-1">
        <div class="col-md-3">
          <strong>Nome </strong>
        </div>
      
        <div class="col-md-9">
          <span>COOPERATIVA DE TRABALHO DOS PROFISSIONAIS DE AGRONOMIA LTDA</span>
        </div>
      </div>
      
      <div class="d-flex m-1">
        <div class="col-md-3">
          <strong>CNPJ </strong>
        </div>
        <div class="col-md-9">
          <span>72.042.799/0001-90</span>
        </div>
      </div>
      
      <div class="d-flex m-1">
        <div class="col-md-3">
          <strong>Banco </strong>
        </div>
        
        <div class="col-md-9">
          <span>Banco do Brasil - <strong>Ag.</strong> 3409-6 <strong>C/C</strong> 75.505-2</span>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      buttonClicked: false,
    };
  },
  props: {
    value: {           
      type: Boolean,
      default: false
    },
    qrCodeImage: {
      type: String,
      default: ""
    },
    textAreaData: {
      type: String,
      default: ""
    },
    titulo: {
      type: String,
      default: ""
    },
    valor: {
      default: 0
    },
  },
  methods: {
    async copiarConteudo() {
      const textarea = document.getElementById("text-copiaCola");

      if (!textarea) {
        this.$tools.alerta("Elemento não encontrado.", "error");
        return;
      }
    
      try {
        await navigator.clipboard.writeText(textarea.value);
      
        this.$tools.alerta("Conteúdo copiado com sucesso", "success");
        this.buttonClicked = true;
      } catch {
        this.$tools.alerta("Erro ao copiar o conteúdo.", "error");
      }
    },

    enviarEmail() {
      this.$tools.alerta("E-mail enviado com sucesso", "success");
    }
  },
  computed: {
    buttonVariant() {
      return this.buttonClicked ? 'secondary' : 'success';
    },
    buttonStyle() {
      return this.buttonClicked
        ? { 'background-color': '#6c757d', 'color': '#fff' }
        : { 'background-color': '#07331A', 'color': '#fff' };
    },
    mostraQRCode: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); this.buttonClicked = false; }
    }
  },
};
</script>

<style scoped>
#imgQrCode {
  margin-bottom: 10px;
  border-radius: 10px;
  border: 2px solid #07331A;
  width: 25%!important;
}
</style>